export const services = [
  {
    label: "Github",
    name: "github"
  },
  {
    label: "Gitlab",
    name: "gitlab"
  },
  {
    label: "Zenodo",
    name: "zenodo"
  },
  {
    label: "ORCID",
    name: "orcid"
  }
];
